import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const LoginForm = ({ selectedRole, onSubmit, onForgotPassword }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const mockCredentials = {
    dentist: { username: 'dr.anderson@dental.com', password: 'Dentist@2026' },
    hygienist: { username: 'hygienist.martinez@dental.com', password: 'Hygienist@2026' },
    admin: { username: 'admin@dental.com', password: 'Admin@2026' }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData?.username?.trim()) {
      newErrors.username = 'Username is required';
    } else if (!formData?.username?.includes('@')) {
      newErrors.username = 'Please enter a valid email address';
    }
    
    if (!formData?.password) {
      newErrors.password = 'Password is required';
    } else if (formData?.password?.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (!validateForm()) return;
    
    setIsLoading(true);
    
    setTimeout(() => {
      const validCredentials = mockCredentials?.[selectedRole];
      
      if (
        formData?.username === validCredentials?.username &&
        formData?.password === validCredentials?.password
      ) {
        onSubmit(formData);
      } else {
        setErrors({
          submit: `Invalid credentials. Use ${validCredentials?.username} / ${validCredentials?.password}`
        });
      }
      setIsLoading(false);
    }, 1000);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5">
      {errors?.submit && (
        <div className="flex items-start gap-3 p-4 bg-destructive/10 border border-destructive rounded-lg">
          <Icon name="AlertCircle" size={20} color="var(--color-destructive)" />
          <p className="text-sm text-destructive flex-1">{errors?.submit}</p>
        </div>
      )}
      <Input
        label="Username / Email"
        type="email"
        name="username"
        placeholder="Enter your email address"
        value={formData?.username}
        onChange={handleChange}
        error={errors?.username}
        required
      />
      <div className="relative">
        <Input
          label="Password"
          type={showPassword ? 'text' : 'password'}
          name="password"
          placeholder="Enter your password"
          value={formData?.password}
          onChange={handleChange}
          error={errors?.password}
          required
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-[38px] text-muted-foreground hover:text-foreground transition-smooth"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={20} />
        </button>
      </div>
      <div className="flex items-center justify-between">
        <Checkbox
          label="Remember me on this device"
          name="rememberMe"
          checked={formData?.rememberMe}
          onChange={handleChange}
        />
        <button
          type="button"
          onClick={onForgotPassword}
          className="text-sm font-medium text-primary hover:text-primary/80 transition-smooth"
        >
          Forgot Password?
        </button>
      </div>
      <Button
        type="submit"
        variant="default"
        fullWidth
        loading={isLoading}
        iconName="LogIn"
        iconPosition="left"
      >
        Sign In Securely
      </Button>
      <div className="pt-4 border-t border-border">
        <p className="text-xs text-center text-muted-foreground">
          Mock credentials for {selectedRole}:<br />
          <span className="font-mono font-semibold text-foreground">
            {mockCredentials?.[selectedRole]?.username}
          </span>
          {' / '}
          <span className="font-mono font-semibold text-foreground">
            {mockCredentials?.[selectedRole]?.password}
          </span>
        </p>
      </div>
    </form>
  );
};

export default LoginForm;